module.exports = __webpack_public_path__ + "img/wf-finishing-position-27.373abcd7.svg";